// PR 51 · P51-B2 (owner review 21-Oct-2026) — 316(a) held by a REVIEW engagement: opened read-only in the generic form dialog
// with its sign-off bar and the N/A action — EN + AR. Merged into lib/i18n.js translations (big-file rule).
export const I18N_P51 = {
  en: {
    legacy316a: {
      banner: "316(a) is the audit form. On a review engagement the final analytical review is kept on R316(a) — this 316(a) is read-only. Mark it not applicable, or sign it off as it stands.",
      openR316a: "Open R316(a)",
      markNa: "Mark not applicable",
      markApplicable: "Mark applicable",
      naReasonDefault: "Not applicable — replaced by R316(a) (review engagement)",
    },
    errors: {
      FORM_316A_NOT_FOR_REVIEW: "316(a) is the audit form. On a review engagement the final analytical review is kept on R316(a) — this 316(a) is read-only; mark it not applicable.",
    },
  },
  ar: {
    legacy316a: {
      banner: "النموذج 316(a) خاص بالمراجعة. في ارتباط الفحص تُحفظ المراجعة التحليلية النهائية في النموذج R316(a) — هذا النموذج 316(a) للقراءة فقط. اجعله غير منطبق، أو وقّع عليه كما هو.",
      openR316a: "فتح النموذج R316(a)",
      markNa: "اجعله غير منطبق",
      markApplicable: "اجعله منطبقًا",
      naReasonDefault: "غير منطبق — استُبدل بالنموذج R316(a) (ارتباط فحص)",
    },
    errors: {
      FORM_316A_NOT_FOR_REVIEW: "النموذج 316(a) خاص بالمراجعة. في ارتباط الفحص تُحفظ المراجعة التحليلية النهائية في النموذج R316(a) — هذا النموذج 316(a) للقراءة فقط؛ اجعله غير منطبق.",
    },
  },
};

export default I18N_P51;
